import type { InsuranceParamsLeasingDto } from 'BrokerTsLib/src/dtos'
import { SelectionType } from 'BrokerTsLib/src/enums'
import { priceFormat } from 'BrokerTsLib/src/Utils/formatPrice'
import moment from 'moment'

import { useSelections } from '.'
import type { InsuranceInfoProps } from '../components/InsuranceInfo'

export const useInsuranceInfo: (insuranceParams?: InsuranceParamsLeasingDto) => InsuranceInfoProps[] = (insuranceParams?: InsuranceParamsLeasingDto) => {
  const { data: dataLt } = useSelections(SelectionType.LeasingType)
  const { data: dataPf } = useSelections(SelectionType.FrekvencePlatby)
  const leasingTypes = dataLt?.data ?? []
  const paymentFrequencies = dataPf?.data ?? []

  if (!insuranceParams) return []

  const infos = []

  if (insuranceParams.generalParams.insuranceStartDate) {
    const date = new Date(insuranceParams.generalParams.insuranceStartDate)
    date.setHours(0, 0, 0, 0)

    const now = new Date()
    now.setHours(0, 0, 0, 0)
    infos.push({
      label: 'Počátek pojištění',
      value: moment(date).format('D. M. YYYY'),
      hasWarning: date < now,
    })
  }

  if (insuranceParams.vehicle.price)
    infos.push({
      label: 'Pojistná částka',
      value: `${priceFormat(insuranceParams.vehicle.price)} ${insuranceParams.vehicle.priceIncludeVat ? 's DPH' : 'bez DPH'}`,
    })

  if (insuranceParams.leasingData?.leasingTypeId)
    infos.push({
      label: 'Typ financování',
      value: leasingTypes.find(x => x.id == insuranceParams.leasingData!.leasingTypeId)?.description ?? '',
    })

  if (insuranceParams.leasingData?.leasingTerm)
    infos.push({
      label: 'Délka financování',
      value: `${insuranceParams.leasingData.leasingTerm} měsíců`,
    })

  if (insuranceParams.generalParams.paymentFrequency)
    infos.push({
      label: 'Frekvence placení',
      value: paymentFrequencies.find(x => x.id == insuranceParams.generalParams.paymentFrequency)?.description ?? '',
    })

  return infos
}
